// ©2024 Austin App House. All rights reserved.
import React, { Component } from 'react';
import { MDBBtn, MDBCol, MDBRow } from 'mdbreact';
import DatePicker from 'react-datepicker';
import combineDateAndTime from '../../../../utils/addTimeToDatefromAM_PMFormatString';
import CustomTimePicker from '../../../layout/CustomTimePicker';
import Notification from '../../../notification';

class EditCheckInCheckOut extends Component {
  state = { ...this.props.checkInCheckOutToEdit };

  handlerChange = (date, name) => {
    this.setState({
      [name]: date,
    });
  };

  saveEditedData = async (event) => {
    event.preventDefault();
    const sendData = {
      checkInDate: (!this.state.edit_check_in_date) ? '' : await combineDateAndTime(this.state.edit_check_in_date, this.state.edit_check_in_time),
      checkOutDate: (!this.state.edit_check_out_date) ? '' : await combineDateAndTime(this.state.edit_check_out_date, this.state.edit_check_out_time),
      description: this.state.work_description || '',
    };
    if (sendData.checkOutDate) {
      if (new Date(sendData.checkOutDate) < new Date(sendData?.checkInDate)) {
        // eslint-disable-next-line consistent-return
        return Notification('warning', { message: 'Check-out time must be later than check-in time' });
      }
      if ((!sendData.description.trim())) {
        return Notification('warning', { message: 'Please Enter Description of Work Performed!' });
      }
    }
    // eslint-disable-next-line react/destructuring-assignment
    const result = await this.props
      .editCheckInCheckOutData(
        sendData,
        this.props.currentWorkOrder._id,
        this.state.check_in_out_id,
      );
    if (result) {
      this.setState({
        // eslint-disable-next-line react/no-unused-state
        showEditCheckInfo: false,
        edit_check_in_time: '12:00AM',
        edit_check_out_time: '12:00AM',
        edit_check_in_date: '',
        edit_check_out_date: '',
      });
    }
  };

  render() {
    const { cancelEdit, currentWorkOrder } = this.props;
    const {
      edit_check_in_date,
      edit_check_out_date,
      work_description,
      edit_check_in_time,
      edit_check_out_time,
      check_in_time_string,
      check_out_time_string,
    } = this.state;
    return (
      <div className=" d-flex edit_file_div">
        <div>
          <div>
            <div className="field_row">
                <div className="field_name">
              <label className="font11">Check In Date</label>
                </div>
                <div className="field_block">
              <DatePicker
                disabled={currentWorkOrder.status !== 'assigned'}
                className="form-control cind"
                dateFormat={
                  currentWorkOrder.status !== 'assigned'
                    ? 'MM/dd/yyyy h:mm'
                    : 'MM/dd/yyyy'
                }
                selected={edit_check_in_date}
                id="edit_check_in_date"
                value={edit_check_in_date}
                onChange={(date) => {
                  this.handlerChange(date, 'edit_check_in_date');
                }}
              />
                </div>
            </div>
            {
              currentWorkOrder.status === 'assigned'
              && (
                <div className="field_row">
                <div className="field_name">
                  <label className="font11">Check In Time</label>
                </div>
                    <div className="field_block">
                  <CustomTimePicker
                    className="cint"
                    id="timePickerEditCheckIn"
                    getValue={(date) => {
                      this.handlerChange(date, 'edit_check_in_time');
                    }}
                    hours={check_in_time_string && check_in_time_string.slice(0, check_in_time_string.indexOf(':'))}
                    minutes={check_in_time_string && check_in_time_string.slice(check_in_time_string.indexOf(':') + 1, -2)}
                    dayTime={check_in_time_string && check_in_time_string.slice(-2)}
                    hoursFormat={12}
                    value={edit_check_in_time}
                  />
                    </div>
                </div>
              )
            }
            <div className="field_row">
            <div className="field_name">
              <label className="font11">Check Out Date</label>
            </div>
                <div className="field_block">
              <DatePicker
                disabled={currentWorkOrder.status !== 'assigned'}
                className="form-control coutd"
                dateFormat={
                  currentWorkOrder.status !== 'assigned'
                    ? 'MM/dd/yyyy h:mm'
                    : 'MM/dd/yyyy'
                }
                selected={edit_check_out_date}
                id="edit_check_out_date"
                value={edit_check_out_date}
                onChange={(date) => {
                  this.handlerChange(date, 'edit_check_out_date');
                }}
              />
                </div>
            </div>
            {
              currentWorkOrder.status === 'assigned'
              && (
                <div className="field_row">
                <div className="field_name">
                  <label className="font11">Check Out Time</label>
                </div>
                    <div className="field_block">
                  <CustomTimePicker
                    className="cint"
                    id="timePickerEditCheckOut"
                    getValue={(date) => {
                      this.handlerChange(date, 'edit_check_out_time');
                    }}
                    hoursFormat={12}
                    hours={check_out_time_string && check_out_time_string.slice(0, check_out_time_string.indexOf(':'))}
                    minutes={check_out_time_string && check_out_time_string.slice(check_out_time_string.indexOf(':') + 1, -2)}
                    dayTime={check_out_time_string && check_out_time_string.slice(-2)}
                    value={edit_check_out_time}
                  />
                    </div>
                </div>
              )
            }
          </div>
          <div className="field_row">
          <div className="field_name">
              <label className="font11">Work Description</label>
          </div>
              <div className="field_block">
              <textarea
                type="text"
                className="form-control descheck font11"
                placeholder="Description/Remark"
                id="work_description"
                name="work_description"
                value={work_description}
                onChange={(event) => {
                  this.handlerChange(event.target.value, 'work_description');
                }}
              />
              </div>
          </div>
          <div className="dashboard-modal-footer">
            <div
              className="dashboard-modal-footer"
            >
              <button
                color="info"
                className="standard_btn lightest_btn"
                onClick={this.saveEditedData}
              >
                Save
              </button>
              <button
                color="deep-orange"
                className="dashboard-btn dashboard-btn--secondary"
                onClick={cancelEdit}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EditCheckInCheckOut;
